import React, { useContext, useEffect, useState, useRef } from 'react';
import { ModalContext } from '../../components/contexts';
import { useNavigate, useLocation } from 'react-router-dom';
import ValidateService from '../../services/ValidateService';
import { NumericFormat } from 'react-number-format';
import { nlPost } from '../../apis/notLoginApi';

const SurveySymptom = () => {
  useEffect(() => {
    document.title = '증상조사표';
  }, []);

  const location = useLocation();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    neckPainYn: 'N',
    upperArmPainYn: 'N',
    lowerArmPainYn: 'N',
    wristPainYn: 'N',
    trunkPainYn: 'N',
    legPainYn: 'N',
  });

  const getWrkrInfo = () => {
    const url = '/aia/survey/getWrkrInfo.do';
    const param = { userSn: formData.userSn };

    nlPost(url, param)
      .then(response => {
        setFormData(prevFormData => ({
          ...prevFormData,
          wrkrNm: response.wrkrNm,
          entSn: response.entSn,
        }));
      })
      .catch(error => {});
  };

  useEffect(() => {
    if (formData.userSn != '' && formData.userSn != null) {
      getWrkrInfo();
    }
  }, [formData.userSn]);

  // 입력값 state에 저장
  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const handleRadioChange = (id, value) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const userSnValue = queryParams.get('userSn');
    const yearValue = queryParams.get('exmnYr');

    setFormData(prevFormData => ({
      ...prevFormData,
      userSn: userSnValue || prevFormData.userSn,
      exmnYr: yearValue,
    }));
  }, [location.search]);

  const insertSurveySymptom = async () => {
    const url = '/aia/survey/insertSurveySymptom.do';
    const param = formData;

    nlPost(url, param)
      .then(response => {
        modalService.successAlert('변경사항을 저장했습니다.', () => {
          navigate('/ai/surveySymptomCmplt');
        });
      })
      .catch(error => {});
  };

  const handleCheckboxChange = e => {
    const { name, checked } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: checked ? 'Y' : 'N',
    }));
  };

  const insertProcess = async () => {
    try {
      await beforeInsert();
    } catch (e) {
      modalService.errorAlert('에러가 발생했습니다. 다시 시도해 주세요.');
    }
  };

  const beforeInsert = async () => {
    const validationRules = {
      wrkrNm: { presence: true },
      wrkrGndr: { presence: true },
      wrkrAge: { presence: true },
      wrkrMrgYn: { presence: true },
      wrkrCrrYr: { presence: true },
      wrkrCrrMm: { presence: true },
      wrkrDept: { presence: true },
      wrkrWork: { presence: true },
      workTtl: { presence: true },
      workHr: { presence: true },
      recessHr: { presence: true },
      recessNmtm: { presence: true },
      workDesc: { presence: true },
      workPrdYr: { presence: true },
      workPrdMm: { presence: true },
      bfrWorkCn: { presence: true },
      bfrWorkPrdYr: { presence: true },
      bfrWorkPrdMm: { presence: true },

      hby: { presence: true },
      houseworkHr: { presence: true },
      dss: { presence: true },
      injrYn: { presence: true },
      workLoad: { presence: true },
      painYn: { presence: true },
    };

    const altKey = {
      wrkrNm: '성명',
      wrkrGndr: '성별',
      wrkrAge: '연령',
      wrkrMrgYn: '결혼 여부',
      wrkrCrrYr: '직장 경력(년)',
      wrkrCrrMm: '직장 경력(월)',
      wrkrDept: '작업 부서',
      wrkrWork: '작업 라인',
      workTtl: '작업명',
      workHr: '근무 시간',
      recessHr: '휴식 시간(분)',
      recessNmtm: '휴식 횟수',
      workDesc: '작업 내용',
      workPrdYr: '작업기간(년)',
      workPrdMm: '작업기간(월)',
      bfrWorkCn: '이전 작업내용',
      bfrWorkPrdYr: '이전 작업기간(년)',
      bfrWorkPrdMm: '이전 작업기간(월)',

      hby: '여가 및 취미활동',
      houseworkHr: '가사 노동시간',
      dss: '진단 질병',
      dssElps: '질병 경과',
      injrYn: '상해 여부',
      injrPart: '상해 부위',
      workLoad: '육체 부담 정도',
      painYn: '통증 여부',
      neckPainYn: '목 통증 여부',
      upperArmPainYn: '어깨 통증 여부',
      lowerArmPainYn: '팔 통증 여부',
      wristPainYn: '손목/손가락 통증 여부',
      trunkPainYn: '허리 통증 여부',
      legPainYn: '다리/발 통증 여부',

      neckPainPrd: '목 통증 기간',
      neckPainIntens: '목 통증 강도',
      neckPainFreq: '목 통증 빈도',
      bfrWeekNeckPainYn: '지난주 목 통증 여부',
      bfrYrNeckPainMdtrtYn: '작년 목 통증 치료여부',
      bfrYrNeckPainMdtrtEtc: '작년 목 통증 치료내용(기타)',

      upperArmPainPart: '어깨 통증 부위',
      upperArmPainPrd: '어깨 통증 기간',
      upperArmPainIntens: '어깨 통증 강도',
      upperArmPainFreq: '어깨 통증 빈도',
      bfrWeekUpperArmPainYn: '지난주 어깨 통증 여부',
      bfrYrUpperArmPainMdtrtYn: '작년 어깨 목 통증 치료여부',
      bfrYrUpperArmPainMdtrtEtc: '작년 어깨 통증 치료내용(기타)',

      lowerArmPainPart: '팔 통증 부위',
      lowerArmPainPrd: '팔 통증 기간',
      lowerArmPainIntens: '팔 통증 강도',
      lowerArmPainFreq: '팔 통증 빈도',
      bfrWeekLowerArmPainYn: '지난주 팔 통증 여부',
      bfrYrLowerArmPainMdtrtYn: '작년 목 통증 치료여부',
      bfrYrLowerArmPainMdtrtEtc: '작년 팔 통증 치료내용(기타)',

      wristPainPart: '손목/손가락 통증 부위',
      wristPainPrd: '손목/손가락 통증 기간',
      wristPainIntens: '손목/손가락 통증 강도',
      wristPainFreq: '손목/손가락 통증 빈도',
      bfrWeekWristPainYn: '지난주 손목/손가락 통증 여부',
      bfrYrWristPainMdtrtYn: '작년 손목/손가락 통증 치료여부',
      bfrYrWristPainMdtrtEtc: '작년 손목/손가락 통증 치료내용(기타)',

      trunkPainPrd: '허리 통증 기간',
      trunkPainIntens: '허리 통증 강도',
      trunkPainFreq: '허리 통증 빈도',
      bfrWeekTrunkPainYn: '지난주 허리 통증 여부',
      bfrYrWristPainMdtrtYn: '작년 허리 통증 치료여부',
      bfrYrTrunkPainMdtrtEtc: '작년 허리 통증 치료내용(기타)',

      legPainPart: '다리/발 통증 부위',
      legPainPrd: '다리/발 통증 기간',
      legPainIntens: '다리/발 통증 강도',
      legPainFreq: '다리/발 통증 빈도',
      bfrWeekLegPainYn: '지난주 다리/발 통증 여부',
      bfrYrLegPainMdtrtYn: '작년 다리/발 통증 치료여부',
      bfrYrLegPainMdtrtEtc: '작년 다리/발 통증 치료내용(기타)',
    };

    if (formData.dss == 'F') {
      validationRules.dssElps = { presence: false };
    } else {
      validationRules.dssElps = { presence: true };
    }

    if (formData.injrYn == 'Y') {
      validationRules.injrPart = { presence: true };
    }

    if (
      formData.painYn == 'Y' &&
      formData.neckPainYn === 'N' &&
      formData.upperArmPainYn === 'N' &&
      formData.lowerArmPainYn === 'N' &&
      formData.wristPainYn === 'N' &&
      formData.trunkPainYn === 'N' &&
      formData.legPainYn === 'N'
    ) {
      modalService.noticeAlert('통증 여부를 선택해 주세요.');
      return;
    }

    if (formData.neckPainYn === 'Y') {
      validationRules.neckPainPrd = { presence: true };
      validationRules.neckPainIntens = { presence: true };
      validationRules.neckPainFreq = { presence: true };
      validationRules.bfrWeekNeckPainYn = { presence: true };
      validationRules.bfrYrNeckPainMdtrtYn = { presence: true };
      if (formData.bfrYrNeckPainMdtrtYn == 'F') {
        validationRules.bfrYrNeckPainMdtrtEtc = { presence: true };
      }
    }

    if (formData.upperArmPainYn === 'Y') {
      validationRules.upperArmPainPart = { presence: true };
      validationRules.upperArmPainPrd = { presence: true };
      validationRules.upperArmPainIntens = { presence: true };
      validationRules.upperArmPainFreq = { presence: true };
      validationRules.bfrWeekUpperArmPainYn = { presence: true };
      validationRules.bfrYrUpperArmPainMdtrtYn = { presence: true };
      if (formData.bfrYrUpperArmPainMdtrtYn == 'F') {
        validationRules.bfrYrUpperArmPainMdtrtYn = { presence: true };
      }
    }

    if (formData.lowerArmPainYn === 'Y') {
      validationRules.lowerArmPainPart = { presence: true };
      validationRules.lowerArmPainPrd = { presence: true };
      validationRules.lowerArmPainIntens = { presence: true };
      validationRules.lowerArmPainFreq = { presence: true };
      validationRules.bfrWeekLowerArmPainYn = { presence: true };
      validationRules.bfrYrLowerArmPainMdtrtYn = { presence: true };
      if (formData.bfrYrLowerArmPainMdtrtYn == 'F') {
        validationRules.bfrYrLowerArmPainMdtrtEtc = { presence: true };
      }
    }

    if (formData.wristPainYn === 'Y') {
      validationRules.wristPainPart = { presence: true };
      validationRules.wristPainPrd = { presence: true };
      validationRules.wristPainIntens = { presence: true };
      validationRules.wristPainFreq = { presence: true };
      validationRules.bfrWeekWristPainYn = { presence: true };
      validationRules.bfrYrWristPainMdtrtYn = { presence: true };
      if (formData.bfrYrWristPainMdtrtYn == 'F') {
        validationRules.bfrYrWristPainMdtrtEtc = { presence: true };
      }
    }

    if (formData.trunkPainYn === 'Y') {
      validationRules.trunkPainPrd = { presence: true };
      validationRules.trunkPainIntens = { presence: true };
      validationRules.trunkPainFreq = { presence: true };
      validationRules.bfrWeekTrunkPainYn = { presence: true };
      validationRules.bfrYrTrunkPainMdtrtYn = { presence: true };
      if (formData.bfrYrTrunkPainMdtrtYn == 'F') {
        validationRules.bfrYrTrunkPainMdtrtEtc = { presence: true };
      }
    }

    if (formData.legPainYn === 'Y') {
      validationRules.legPainPart = { presence: true };
      validationRules.legPainPrd = { presence: true };
      validationRules.legPainIntens = { presence: true };
      validationRules.legPainFreq = { presence: true };
      validationRules.bfrWeekLegPainYn = { presence: true };
      validationRules.bfrYrLegPainMdtrtYn = { presence: true };
      if (formData.bfrYrLegPainMdtrtYn == 'F') {
        validationRules.bfrYrLegPainMdtrtEtc = { presence: true };
      }
    }

    if (
      await validateService.validateJsCall(formData, validationRules, altKey)
    ) {
      return;
    }

    await insertSurveySymptom();
  };

  return (
    <>
      <div className="inner narrow">
        {/* 페이지 타이틀 영역 */}
        <div className="page-title-wrap">
          <h1 className="h-tit">증상조사표</h1>{' '}
        </div>
        {/* //페이지 타이틀 영역 */}

        {/* 컨텐츠 영역 */}
        <div className="conts-area">
          <div className="conts-wrap">
            <div className="conts-wrap">
              {/* 정보입력 */}
              <div>
                {/* 기본 정보 입력 */}
                <div className="txt-box bg-white">
                  <h2 className="box-tit1">기본 정보</h2>
                  <div className="box-cnt">
                    {/* 성명 */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        <label>1-1. 성명 : {formData.wrkrNm}</label>
                      </h3>
                    </div>
                    {/* //성명 */}
                    {/* 성별 */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        1-2. 귀하의 성별은 무엇입니까?
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="row chk-area chk-column">
                            <div className="form-check ">
                              <input
                                type="radio"
                                name="wrkrGndr"
                                id="wrkrGndrM"
                                value="M"
                                checked={formData.wrkrGndr === 'M'}
                                onChange={e =>
                                  handleRadioChange('wrkrGndr', e.target.value)
                                }
                              />
                              <label htmlFor="wrkrGndrM">남성</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="wrkrGndr"
                                id="wrkrGndrF"
                                value="F"
                                checked={formData.wrkrGndr === 'F'}
                                onChange={e =>
                                  handleRadioChange('wrkrGndr', e.target.value)
                                }
                              />
                              <label htmlFor="wrkrGndrF">여성</label>{' '}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* //성별 */}

                    {/* 연령 */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        <label htmlFor="wrkrAge">
                          1-3. 연령을 입력해 주세요.
                        </label>
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="input-group">
                            만
                            <NumericFormat
                              type="text"
                              id="wrkrAge"
                              className="form-control"
                              value={formData.wrkrAge || ''}
                              onChange={handleInputChange}
                              thousandSeparator={false}
                              maxLength={2}
                              allowLeadingZeros={true}
                              allowNegative={false}
                              style={{ width: '80px' }}
                              aria-labelledby="wrkrAge"
                            />
                            세
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* //연령 */}
                    {/* 결혼여부 */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        1-4. 결혼여부를 입력해 주세요.
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="row chk-area chk-column">
                            <div className="form-check ">
                              <input
                                type="radio"
                                name="wrkrMrgYn"
                                id="wrkrMrgYnY"
                                value="Y"
                                checked={formData.wrkrMrgYn === 'Y'}
                                onChange={e =>
                                  handleRadioChange('wrkrMrgYn', e.target.value)
                                }
                              />
                              <label htmlFor="wrkrMrgYnY">기혼</label>
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="wrkrMrgYn"
                                id="wrkrMrgYnN"
                                value="N"
                                checked={formData.wrkrMrgYn === 'N'}
                                onChange={e =>
                                  handleRadioChange('wrkrMrgYn', e.target.value)
                                }
                              />
                              <label htmlFor="wrkrMrgYnN">미혼</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* //결혼여부 */}

                    {/* 현 직장경력 */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        1-5. 귀하의 현재 직장경력을 입력해주세요.
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="input-group">
                            <NumericFormat
                              type="text"
                              id="wrkrCrrYr"
                              className="form-control"
                              value={formData.wrkrCrrYr || ''}
                              onChange={handleInputChange}
                              thousandSeparator={false}
                              maxLength={2}
                              allowLeadingZeros={true}
                              allowNegative={false}
                              style={{ width: '80px' }}
                              aria-labelledby="wrkrCrrYr"
                            />
                            년
                            <NumericFormat
                              type="text"
                              id="wrkrCrrMm"
                              className="form-control"
                              value={formData.wrkrCrrMm || ''}
                              onChange={handleInputChange}
                              thousandSeparator={false}
                              maxLength={2}
                              allowLeadingZeros={true}
                              allowNegative={false}
                              style={{ width: '80px' }}
                              isAllowed={values => {
                                const { floatValue } = values;
                                return (
                                  floatValue === undefined || floatValue <= 12
                                );
                              }}
                              aria-labelledby="wrkrCrrMm"
                            />
                            개월째 근무 중
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* //현 직장경력 */}
                    {/* 작업부서 */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        1-6. 귀하의 작업 부서를 입력하세요.
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="input-group">
                            <input
                              type="text"
                              id="wrkrDept"
                              className="form-control"
                              value={formData.wrkrDept || ''}
                              onChange={handleInputChange}
                              maxLength={20}
                              style={{ width: '80px' }}
                              aria-labelledby="wrkrDept"
                            />
                            부
                            <input
                              type="text"
                              id="wrkrWork"
                              className="form-control"
                              value={formData.wrkrWork || ''}
                              onChange={handleInputChange}
                              maxLength={20}
                              style={{ width: '80px' }}
                              aria-labelledby="wrkrWork"
                            />
                            라인
                          </div>
                          <div className="input-group">
                            <input
                              type="text"
                              id="workTtl"
                              className="form-control"
                              value={formData.workTtl || ''}
                              onChange={handleInputChange}
                              maxLength={20}
                              aria-labelledby="workTtl"
                            />{' '}
                            작업
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* //작업부서 */}
                    {/* 1일 근무시간 */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        1-7. 하루 근무시간은 어떻게 되십니까?
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="input-group">
                            <NumericFormat
                              type="text"
                              id="workHr"
                              className="form-control"
                              value={formData.workHr || ''}
                              onChange={handleInputChange}
                              thousandSeparator={false}
                              maxLength={2}
                              allowLeadingZeros={true}
                              allowNegative={false}
                              style={{ width: '80px' }}
                              isAllowed={values => {
                                const { floatValue } = values;
                                return (
                                  floatValue === undefined || floatValue <= 24
                                );
                              }}
                              aria-labelledby="workHr"
                            />
                            시간
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* //1일 근무시간 */}
                    {/* 1일 근무시간 */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        1-8. 근무중 휴식시간은 어떻게 되십니까?(식사시간 제외)
                      </h3>
                      <div className="input-group">
                        <NumericFormat
                          type="text"
                          id="recessHr"
                          className="form-control"
                          value={formData.recessHr || ''}
                          onChange={handleInputChange}
                          thousandSeparator={false}
                          maxLength={2}
                          allowLeadingZeros={true}
                          allowNegative={false}
                          style={{ width: '80px' }}
                          aria-labelledby="recessHr"
                        />
                        분씩
                        <NumericFormat
                          type="text"
                          id="recessNmtm"
                          className="form-control"
                          value={formData.recessNmtm || ''}
                          onChange={handleInputChange}
                          thousandSeparator={false}
                          maxLength={2}
                          allowLeadingZeros={true}
                          allowNegative={false}
                          style={{ width: '80px' }}
                          aria-labelledby="recessNmtm"
                        />
                        회 휴식
                      </div>
                    </div>
                    {/* //1일 근무시간 */}
                    {/* 현재작업 */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        1-9. 현재 하고있는 작업을 구체적으로 말씀해 주세요.
                      </h3>
                      <div className="input-group">
                        <input
                          type="text"
                          id="workDesc"
                          className="form-control"
                          value={formData.workDesc || ''}
                          onChange={handleInputChange}
                          maxLength={20}
                          aria-labelledby="workDesc"
                        />
                      </div>
                      <div className="input-group">
                        <NumericFormat
                          type="text"
                          id="workPrdYr"
                          className="form-control"
                          value={formData.workPrdYr || ''}
                          onChange={handleInputChange}
                          thousandSeparator={false}
                          maxLength={2}
                          allowLeadingZeros={true}
                          allowNegative={false}
                          style={{ width: '80px' }}
                          aria-labelledby="workPrdYr"
                        />
                        년
                        <NumericFormat
                          type="text"
                          id="workPrdMm"
                          className="form-control"
                          value={formData.workPrdMm || ''}
                          onChange={handleInputChange}
                          thousandSeparator={false}
                          maxLength={2}
                          allowLeadingZeros={true}
                          allowNegative={false}
                          style={{ width: '80px' }}
                          isAllowed={values => {
                            const { floatValue } = values;
                            return floatValue === undefined || floatValue <= 12;
                          }}
                          aria-labelledby="workPrdMm"
                        />
                        개월째 하고있음
                      </div>
                    </div>
                    {/* //현재작업 */}
                    {/* 이전작업 */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        1-10. 현 작업을 하기 전 했던 작업을 알려주세요.
                      </h3>
                      <div className="input-group">
                        <input
                          type="text"
                          id="bfrWorkCn"
                          className="form-control"
                          value={formData.bfrWorkCn || ''}
                          onChange={handleInputChange}
                          maxLength={20}
                          aria-labelledby="bfrWorkCn"
                        />
                      </div>
                      <div className="input-group">
                        <NumericFormat
                          type="text"
                          id="bfrWorkPrdYr"
                          className="form-control"
                          value={formData.bfrWorkPrdYr || ''}
                          onChange={handleInputChange}
                          thousandSeparator={false}
                          maxLength={2}
                          allowLeadingZeros={true}
                          allowNegative={false}
                          style={{ width: '80px' }}
                          aria-labelledby="bfrWorkPrdYr"
                        />
                        년
                        <NumericFormat
                          type="text"
                          id="bfrWorkPrdMm"
                          className="form-control"
                          value={formData.bfrWorkPrdMm || ''}
                          onChange={handleInputChange}
                          thousandSeparator={false}
                          maxLength={2}
                          allowLeadingZeros={true}
                          allowNegative={false}
                          style={{ width: '80px' }}
                          isAllowed={values => {
                            const { floatValue } = values;
                            return floatValue === undefined || floatValue <= 12;
                          }}
                          aria-labelledby="bfrWorkPrdMm"
                        />
                        개월 동안 했음
                      </div>
                    </div>
                    {/* //이전작업 */}
                  </div>
                </div>
                {/* //기본 정보 입력 */}

                {/* 상세 정보 입력 */}
                <div className="txt-box bg-white">
                  <h2 className="box-tit1">상세 정보</h2>
                  <div className="box-cnt">
                    {/* */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        2-1. 규칙적인(한번에 30분 이상, 1주일에 적어도 2-3회
                        이상) 여가 및 취미활동을 하고 계시는 곳에 체크하여
                        주십시오 .
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="row chk-area chk-column">
                            <div className="form-check">
                              <input
                                type="radio"
                                name="hby"
                                id="hbyA"
                                value="A"
                                checked={formData.hby === 'A'}
                                onChange={e =>
                                  handleRadioChange('hby', e.target.value)
                                }
                              />
                              <label htmlFor="hbyA">컴퓨터 관련활동</label>{' '}
                              {/* 수정됨 */}
                            </div>

                            <div className="form-check">
                              <input
                                type="radio"
                                name="hby"
                                id="hbyB"
                                value="B"
                                checked={formData.hby === 'B'}
                                onChange={e =>
                                  handleRadioChange('hby', e.target.value)
                                }
                              />
                              <label htmlFor="hbyB">
                                악기연주(피아노, 바이올린 등)
                              </label>{' '}
                              {/* 수정됨 */}
                            </div>

                            <div className="form-check">
                              <input
                                type="radio"
                                name="hby"
                                id="hbyC"
                                value="C"
                                checked={formData.hby === 'C'}
                                onChange={e =>
                                  handleRadioChange('hby', e.target.value)
                                }
                              />
                              <label htmlFor="hbyC">뜨개질 자수, 붓글씨</label>{' '}
                              {/* 수정됨 */}
                            </div>

                            <div className="form-check">
                              <input
                                type="radio"
                                name="hby"
                                id="hbyD"
                                value="D"
                                checked={formData.hby === 'D'}
                                onChange={e =>
                                  handleRadioChange('hby', e.target.value)
                                }
                              />
                              <label htmlFor="hbyD">
                                테니스/배드민턴/스쿼시
                              </label>{' '}
                              {/* 수정됨 */}
                            </div>

                            <div className="form-check">
                              <input
                                type="radio"
                                name="hby"
                                id="hbyE"
                                value="E"
                                checked={formData.hby === 'E'}
                                onChange={e =>
                                  handleRadioChange('hby', e.target.value)
                                }
                              />
                              <label htmlFor="hbyE">축구/족구/농구/스키</label>{' '}
                              {/* 수정됨 */}
                            </div>

                            <div className="form-check">
                              <input
                                type="radio"
                                name="hby"
                                id="hbyF"
                                value="F"
                                checked={formData.hby === 'F'}
                                onChange={e =>
                                  handleRadioChange('hby', e.target.value)
                                }
                              />
                              <label htmlFor="hbyF">해당사항 없음</label>{' '}
                              {/* 수정됨 */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* // */}
                    {/* */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        2-2. 귀하의 하루 평균 가사노동시간(밥하기, 빨래하기,
                        청소하기, 2살 미만의 아이 돌보기 등)은 얼마나 됩니까 ?
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="row chk-area chk-column">
                            <div className="form-check ">
                              <input
                                type="radio"
                                name="houseworkHr"
                                id="houseworkHrA"
                                value="A"
                                checked={formData.houseworkHr === 'A'}
                                onChange={e =>
                                  handleRadioChange(
                                    'houseworkHr',
                                    e.target.value
                                  )
                                }
                              />
                              <label htmlFor="houseworkHrA">
                                {' '}
                                거의 하지 않는다
                              </label>{' '}
                            </div>
                            <div className="form-check ">
                              <input
                                type="radio"
                                name="houseworkHr"
                                id="houseworkHrB"
                                value="B"
                                checked={formData.houseworkHr === 'B'}
                                onChange={e =>
                                  handleRadioChange(
                                    'houseworkHr',
                                    e.target.value
                                  )
                                }
                              />
                              <label htmlFor="houseworkHrB"> 1시간 미만</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="houseworkHr"
                                id="houseworkHrC"
                                value="C"
                                checked={formData.houseworkHr === 'C'}
                                onChange={e =>
                                  handleRadioChange(
                                    'houseworkHr',
                                    e.target.value
                                  )
                                }
                              />
                              <label htmlFor="houseworkHrC">
                                {' '}
                                1-2시간 미만
                              </label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="houseworkHr"
                                id="houseworkHrD"
                                value="D"
                                checked={formData.houseworkHr === 'D'}
                                onChange={e =>
                                  handleRadioChange(
                                    'houseworkHr',
                                    e.target.value
                                  )
                                }
                              />
                              <label htmlFor="houseworkHrD">
                                {' '}
                                2-3시간 미만
                              </label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="houseworkHr"
                                id="houseworkHrE"
                                value="E"
                                checked={formData.houseworkHr === 'E'}
                                onChange={e =>
                                  handleRadioChange(
                                    'houseworkHr',
                                    e.target.value
                                  )
                                }
                              />
                              <label htmlFor="houseworkHrE">3시간 이상</label>{' '}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* // */}
                    {/* */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        2-3. 귀하는 의사로부터 다음과 같은 질병에 대해 진단을
                        받은 적이 있습니까 ?(해당 질병에 체크)
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="row chk-area chk-column">
                            <div className="form-check ">
                              <input
                                type="radio"
                                name="dss"
                                id="dssA"
                                value="A"
                                checked={formData.dss === 'A'}
                                onChange={e =>
                                  handleRadioChange('dss', e.target.value)
                                }
                              />
                              <label htmlFor="dssA">류머티스 관절염</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="dss"
                                id="dssB"
                                value="B"
                                checked={formData.dss === 'B'}
                                onChange={e =>
                                  handleRadioChange('dss', e.target.value)
                                }
                              />
                              <label htmlFor="dssB">당뇨병</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="dss"
                                id="dssC"
                                value="C"
                                checked={formData.dss === 'C'}
                                onChange={e =>
                                  handleRadioChange('dss', e.target.value)
                                }
                              />
                              <label htmlFor="dssC">루프스병</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="dss"
                                id="dssD"
                                value="D"
                                checked={formData.dss === 'D'}
                                onChange={e =>
                                  handleRadioChange('dss', e.target.value)
                                }
                              />
                              <label htmlFor="dssD">통풍</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="dss"
                                id="dssE"
                                value="E"
                                checked={formData.dss === 'E'}
                                onChange={e =>
                                  handleRadioChange('dss', e.target.value)
                                }
                              />
                              <label htmlFor="dssE">알코올 중독</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="dss"
                                id="dssF"
                                value="F"
                                checked={formData.dss === 'F'}
                                onChange={e =>
                                  handleRadioChange('dss', e.target.value)
                                }
                              />
                              <label htmlFor="dssF">없다</label>{' '}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* // */}
                    {/* */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        (2-3번 문항의 질병에 체크한 경우) 현재 상태는
                        어떻습니까?
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="row chk-area chk-column">
                            <div className="form-check ">
                              <input
                                type="radio"
                                name="dssElps"
                                id="dssElpsA"
                                value="A"
                                checked={formData.dssElps === 'A'}
                                onChange={e =>
                                  handleRadioChange('dssElps', e.target.value)
                                }
                                disabled={formData.dss === 'F'}
                              />
                              <label htmlFor="dssElpsA">완치</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="dssElps"
                                id="dssElpsB"
                                value="B"
                                checked={formData.dssElps === 'B'}
                                onChange={e =>
                                  handleRadioChange('dssElps', e.target.value)
                                }
                                disabled={formData.dss === 'F'}
                              />
                              <label htmlFor="dssElpsB">치료나 관찰중</label>{' '}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* // */}
                    {/* */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        2-4. 과거에 운동 중 혹은 사고로(교통사고, 넘어짐, 추락
                        등) 인해 손/손가락/손목, 팔/팔꿈치, 어깨, 목, 허리,
                        다리/발 부위를 다친 적인 있습니까 ?
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="row chk-area chk-column">
                            <div className="form-check ">
                              <input
                                type="radio"
                                name="injrYn"
                                id="injrYnN"
                                value="N"
                                checked={formData.injrYn === 'N'}
                                onChange={e =>
                                  handleRadioChange('injrYn', e.target.value)
                                }
                              />
                              <label htmlFor="injrYnN">아니오</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="injrYn"
                                id="injrYnY"
                                value="Y"
                                checked={formData.injrYn === 'Y'}
                                onChange={e =>
                                  handleRadioChange('injrYn', e.target.value)
                                }
                              />
                              <label htmlFor="injrYnY">예</label>{' '}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* // */}
                    {/* */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        (2-4번 문항에 '예'라고 대답한 경우) 상해 부위는?
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="row chk-area chk-column">
                            <div className="form-check ">
                              <input
                                type="radio"
                                name="injrPart"
                                id="injrPartA"
                                value="A"
                                disabled={formData.injrYn !== 'Y'}
                                checked={formData.injrPart === 'A'}
                                onChange={e =>
                                  handleRadioChange('injrPart', e.target.value)
                                }
                              />
                              <label htmlFor="injrPartA">손/손가락/손목</label>{' '}
                            </div>
                            <div className="form-check ">
                              <input
                                type="radio"
                                name="injrPart"
                                id="injrPartB"
                                value="B"
                                checked={formData.injrPart === 'B'}
                                disabled={formData.injrYn !== 'Y'}
                                onChange={e =>
                                  handleRadioChange('injrPart', e.target.value)
                                }
                              />
                              <label htmlFor="injrPartB">팔/팔꿈치</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="injrPart"
                                id="injrPartC"
                                value="C"
                                checked={formData.injrPart === 'C'}
                                disabled={formData.injrYn !== 'Y'}
                                onChange={e =>
                                  handleRadioChange('injrPart', e.target.value)
                                }
                              />
                              <label htmlFor="injrPartC">어깨</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="injrPart"
                                id="injrPartD"
                                value="D"
                                checked={formData.injrPart === 'D'}
                                disabled={formData.injrYn !== 'Y'}
                                onChange={e =>
                                  handleRadioChange('injrPart', e.target.value)
                                }
                              />
                              <label htmlFor="injrPartD">목</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="injrPart"
                                id="injrPartE"
                                value="E"
                                checked={formData.injrPart === 'E'}
                                disabled={formData.injrYn !== 'Y'}
                                onChange={e =>
                                  handleRadioChange('injrPart', e.target.value)
                                }
                              />
                              <label htmlFor="injrPartE">허리</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="injrPart"
                                id="injrPartF"
                                value="F"
                                checked={formData.injrPart === 'F'}
                                disabled={formData.injrYn !== 'Y'}
                                onChange={e =>
                                  handleRadioChange('injrPart', e.target.value)
                                }
                              />
                              <label htmlFor="injrPartF">다리/발</label>{' '}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* // */}
                    {/* */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        2-5. 현재 하고 계시는 일의 육체적 부담 정도는 어느
                        정도라고 생각합니까 ?{' '}
                      </h3>
                      <div className="form-group">
                        <div className="form-conts">
                          <div className="row chk-area chk-column">
                            <div className="form-check ">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="workLoad"
                                  id="workLoadA"
                                  value="A"
                                  checked={formData.workLoad === 'A'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'workLoad',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="workLoadA">
                                  전혀 힘들지 않음
                                </label>{' '}
                              </div>
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="workLoad"
                                id="workLoadB"
                                value="B"
                                checked={formData.workLoad === 'B'}
                                onChange={e =>
                                  handleRadioChange('workLoad', e.target.value)
                                }
                              />
                              <label htmlFor="workLoadB">견딜만 함</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="workLoad"
                                id="workLoadC"
                                value="C"
                                checked={formData.workLoad === 'C'}
                                onChange={e =>
                                  handleRadioChange('workLoad', e.target.value)
                                }
                              />
                              <label htmlFor="workLoadC">약간 힘듦</label>{' '}
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                name="workLoad"
                                id="workLoadE"
                                value="E"
                                checked={formData.workLoad === 'E'}
                                onChange={e =>
                                  handleRadioChange('workLoad', e.target.value)
                                }
                              />
                              <label htmlFor="workLoadE">매우 힘듦</label>{' '}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* // */}
                    {/* */}
                    <div className="box-sec">
                      <h3 className="box-tit2">
                        2-6. 지난 1년 동안 손/손가락/손목, 팔/팔꿈치, 어깨,
                        허리, 다리/발 중 어느 한 부위에서라도 귀하의 작업과
                        관련하여 통증이나 불편함(통증, 쑤시는 느낌, 뻣뻣함,
                        화끈거리는 느낌, 무감각 혹은 찌릿찌릿함 등)을 느끼신
                        적이 있습니까 ?
                      </h3>
                      <div className="form-group full">
                        <div className="form-conts">
                          <div className="row chk-area chk-column">
                            <div className="form-check lg">
                              <input
                                type="radio"
                                name="painYn"
                                id="painYnN"
                                value="N"
                                checked={formData.painYn === 'N'}
                                onChange={e =>
                                  handleRadioChange('painYn', e.target.value)
                                }
                              />
                              <label htmlFor="painYnN">아니오</label>{' '}
                              <div className="form-check-cnt">
                                <p className="form-check-p">
                                  수고하셨습니다. 설문을 다 마치셨습니다.
                                </p>
                              </div>
                            </div>
                            <div className="form-check lg">
                              <input
                                type="radio"
                                name="painYn"
                                id="painYnY"
                                value="Y"
                                checked={formData.painYn === 'Y'}
                                onChange={e =>
                                  handleRadioChange('painYn', e.target.value)
                                }
                              />
                              <label htmlFor="painYnY">예</label>{' '}
                              <div className="form-check-cnt">
                                <p className="form-check-p">
                                  “예”라고 답하신 분은 아래 표의 통증부위에 모두
                                  체크하고, 해당 통증부위 해당사항에 체크해
                                  주십시오
                                </p>
                                <div className="chk-area chk-column">
                                  <div className="form-check md">
                                    <input
                                      type="checkbox"
                                      name="neckPainYn"
                                      id="chk_1"
                                      checked={formData.neckPainYn === 'Y'}
                                      onChange={handleCheckboxChange}
                                      disabled={formData.painYn !== 'Y'}
                                    />
                                    <label htmlFor="chk_1">목</label>
                                  </div>
                                  <div className="form-check md">
                                    <input
                                      type="checkbox"
                                      id="chk_2"
                                      name="upperArmPainYn"
                                      checked={formData.upperArmPainYn === 'Y'}
                                      onChange={handleCheckboxChange}
                                      disabled={formData.painYn !== 'Y'}
                                    />
                                    <label htmlFor="chk_2">어깨</label>
                                  </div>
                                  <div className="form-check md">
                                    <input
                                      type="checkbox"
                                      name="lowerArmPainYn"
                                      checked={formData.lowerArmPainYn === 'Y'}
                                      onChange={handleCheckboxChange}
                                      disabled={formData.painYn !== 'Y'}
                                      id="chk_3"
                                    />
                                    <label htmlFor="chk_3">팔/팔꿈치</label>
                                  </div>
                                  <div className="form-check md">
                                    <input
                                      type="checkbox"
                                      name="wristPainYn"
                                      checked={formData.wristPainYn === 'Y'}
                                      onChange={handleCheckboxChange}
                                      disabled={formData.painYn !== 'Y'}
                                      id="chk_4"
                                    />
                                    <label htmlFor="chk_4">
                                      손/손목/손가락
                                    </label>
                                  </div>
                                  <div className="form-check md">
                                    <input
                                      type="checkbox"
                                      name="trunkPainYn"
                                      checked={formData.trunkPainYn === 'Y'}
                                      onChange={handleCheckboxChange}
                                      disabled={formData.painYn !== 'Y'}
                                      id="chk_5"
                                    />
                                    <label htmlFor="chk_5">허리</label>
                                  </div>
                                  <div className="form-check md">
                                    <input
                                      type="checkbox"
                                      name="legPainYn"
                                      checked={formData.legPainYn === 'Y'}
                                      onChange={handleCheckboxChange}
                                      disabled={formData.painYn !== 'Y'}
                                      id="chk_6"
                                    />
                                    <label htmlFor="chk_6">다리/발</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* // */}
                  </div>
                </div>
                {/* //상세 정보 입력 */}
                {/* 통증부위-목 */}
                {formData.neckPainYn == 'Y' ? (
                  <div className="txt-box bg-white">
                    <h2 className="box-tit1">통증부위 - 목</h2>
                    <div className="box-cnt">
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          1. 한번 아프기 시작하면 통증 기간은 얼마 동안
                          지속됩니까?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainPrd"
                                  id="neckPainPrdA"
                                  value="A"
                                  checked={formData.neckPainPrd === 'A'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainPrdA">1일 미만</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainPrd"
                                  id="neckPainPrdB"
                                  value="B"
                                  checked={formData.neckPainPrd === 'B'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainPrdB">
                                  1일 - 1주일 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainPrd"
                                  id="neckPainPrdC"
                                  value="C"
                                  checked={formData.neckPainPrd === 'C'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainPrdC">
                                  1주일 - 1달 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainPrd"
                                  id="neckPainPrdD"
                                  value="D"
                                  checked={formData.neckPainPrd === 'D'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainPrdD">
                                  1달 - 6개월 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainPrd"
                                  id="neckPainPrdE"
                                  value="E"
                                  checked={formData.neckPainPrd === 'E'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainPrdE">6개월 이상</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          2. 그때의 아픈 정도는 어느 정도 입니까 ?
                        </h3>
                        <ul className="guide-txt" style={{ marginBottom: 0 }}>
                          <li>
                            약한 통증 : 약간 불편한 정도이나 작업에 열중할 때는
                            못 느낀다.
                          </li>
                          <li>
                            중간 통증 : 작업 중 통증이 있으나 귀가 후 휴식을
                            취하면 괜찮다.
                          </li>
                          <li>
                            심한 통증 : 작업 중 통증이 비교적 심하고 귀가 후에도
                            통증이 계속된다.
                          </li>
                          <li>
                            매우 심한 통증 : 통증 때문에 작업은 물론 일상생활을
                            하기가 어렵다.
                          </li>
                        </ul>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainIntens"
                                  id="neckPainIntensA"
                                  value="A"
                                  checked={formData.neckPainIntens === 'A'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainIntensA">
                                  약한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainIntens"
                                  id="neckPainIntensB"
                                  value="B"
                                  checked={formData.neckPainIntens === 'B'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainIntensB">
                                  중간 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainIntens"
                                  id="neckPainIntensC"
                                  value="C"
                                  checked={formData.neckPainIntens === 'C'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainIntensC">
                                  심한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainIntens"
                                  id="neckPainIntensD"
                                  value="D"
                                  checked={formData.neckPainIntens === 'D'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainIntensD">
                                  매우 심한 통증
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          3. 지난 1년 동안 이러한 증상을 얼마나 자주
                          경험하셨습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainFreq"
                                  id="neckPainFreqA"
                                  value="A"
                                  checked={formData.neckPainFreq === 'A'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainFreqA">
                                  6개월에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainFreq"
                                  id="neckPainFreqB"
                                  value="B"
                                  checked={formData.neckPainFreq === 'B'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainFreqB">
                                  2-3달에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainFreq"
                                  id="neckPainFreqC"
                                  value="C"
                                  checked={formData.neckPainFreq === 'C'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainFreqC">1달에 1번</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainFreq"
                                  id="neckPainFreqD"
                                  value="D"
                                  checked={formData.neckPainFreq === 'D'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainFreqD">
                                  1주일에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="neckPainFreq"
                                  id="neckPainFreqE"
                                  value="E"
                                  checked={formData.neckPainFreq === 'E'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'neckPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="neckPainFreqE">매일</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          4. 지난 1주일 동안에도 이러한 증상이 있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekNeckPainYn"
                                  id="bfrWeekNeckPainYnN"
                                  value="N"
                                  checked={formData.bfrWeekNeckPainYn === 'N'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekNeckPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekNeckPainYnN">
                                  아니오
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekNeckPainYn"
                                  id="bfrWeekNeckPainYnY"
                                  value="Y"
                                  checked={formData.bfrWeekNeckPainYn === 'Y'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekNeckPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekNeckPainYnY">예</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          5. 지난 1년 동안 이러한 통증으로 인해 어떤 일이
                          있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrNeckPainMdtrtYn"
                                  id="bfrYrNeckPainMdtrtYnA"
                                  value="A"
                                  checked={
                                    formData.bfrYrNeckPainMdtrtYn === 'A'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrNeckPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrNeckPainMdtrtYnA">
                                  병원, 한의원 치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrNeckPainMdtrtYn"
                                  id="bfrYrNeckPainMdtrtYnB"
                                  value="B"
                                  checked={
                                    formData.bfrYrNeckPainMdtrtYn === 'B'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrNeckPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrNeckPainMdtrtYnB">
                                  약국치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrNeckPainMdtrtYn"
                                  id="bfrYrNeckPainMdtrtYnC"
                                  value="C"
                                  checked={
                                    formData.bfrYrNeckPainMdtrtYn === 'C'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrNeckPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrNeckPainMdtrtYnC">
                                  병가, 산재
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrNeckPainMdtrtYn"
                                  id="bfrYrNeckPainMdtrtYnD"
                                  value="D"
                                  checked={
                                    formData.bfrYrNeckPainMdtrtYn === 'D'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrNeckPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrNeckPainMdtrtYnD">
                                  작업 전환
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrNeckPainMdtrtYn"
                                  id="bfrYrNeckPainMdtrtYnE"
                                  value="E"
                                  checked={
                                    formData.bfrYrNeckPainMdtrtYn === 'E'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrNeckPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrNeckPainMdtrtYnE">
                                  해당사항 없음
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrNeckPainMdtrtYn"
                                  id="bfrYrNeckPainMdtrtYnF"
                                  value="F"
                                  checked={
                                    formData.bfrYrNeckPainMdtrtYn === 'F'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.neckPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrNeckPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrNeckPainMdtrtYnF">
                                  기타
                                </label>{' '}
                                <input
                                  type="text"
                                  className="form-control"
                                  id="bfrYrNeckPainMdtrtEtc"
                                  value={formData.bfrYrNeckPainMdtrtEtc || ''}
                                  onChange={handleInputChange}
                                  style={{ marginTop: '12px' }}
                                  maxLength={20}
                                  disabled={
                                    formData.bfrYrNeckPainMdtrtYn != 'F'
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {/* //통증부위-목 */}
                {/* 통증부위-어깨 */}
                {formData.upperArmPainYn == 'Y' ? (
                  <div className="txt-box bg-white">
                    <h2 className="box-tit1">통증부위 - 어깨</h2>
                    <div className="box-cnt">
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">1. 통증의 구체적 부위는?</h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainPart"
                                  id="upperArmPainPartA"
                                  value="A"
                                  checked={formData.upperArmPainPart === 'A'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainPartA">
                                  오른쪽
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainPart"
                                  id="upperArmPainPartB"
                                  value="B"
                                  checked={formData.upperArmPainPart === 'B'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainPartB">왼쪽</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainPart"
                                  id="upperArmPainPartC"
                                  value="C"
                                  checked={formData.upperArmPainPart === 'C'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainPartC">
                                  양쪽 모두
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          2. 한번 아프기 시작하면 통증 기간은 얼마 동안
                          지속됩니까?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainPrd"
                                  id="upperArmPainPrdA"
                                  value="A"
                                  checked={formData.upperArmPainPrd === 'A'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainPrdA">
                                  1일 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainPrd"
                                  id="upperArmPainPrdB"
                                  value="B"
                                  checked={formData.upperArmPainPrd === 'B'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainPrdB">
                                  1일 - 1주일 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainPrd"
                                  id="upperArmPainPrdC"
                                  value="C"
                                  checked={formData.upperArmPainPrd === 'C'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainPrdC">
                                  1주일 - 1달 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainPrd"
                                  id="upperArmPainPrdD"
                                  value="D"
                                  checked={formData.upperArmPainPrd === 'D'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainPrdD">
                                  1달 - 6개월 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainPrd"
                                  id="upperArmPainPrdE"
                                  value="E"
                                  checked={formData.upperArmPainPrd === 'E'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainPrdE">
                                  6개월 이상
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          3. 그때의 아픈 정도는 어느 정도 입니까 ?
                        </h3>
                        <ul className="guide-txt" style={{ marginBottom: 0 }}>
                          <li>
                            약한 통증 : 약간 불편한 정도이나 작업에 열중할 때는
                            못 느낀다.
                          </li>
                          <li>
                            중간 통증 : 작업 중 통증이 있으나 귀가 후 휴식을
                            취하면 괜찮다.
                          </li>
                          <li>
                            심한 통증 : 작업 중 통증이 비교적 심하고 귀가 후에도
                            통증이 계속된다.
                          </li>
                          <li>
                            매우 심한 통증 : 통증 때문에 작업은 물론 일상생활을
                            하기가 어렵다.
                          </li>
                        </ul>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainIntens"
                                  id="upperArmPainIntensA"
                                  value="A"
                                  checked={formData.upperArmPainIntens === 'A'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainIntensA">
                                  약한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainIntens"
                                  id="upperArmPainIntensB"
                                  value="B"
                                  checked={formData.upperArmPainIntens === 'B'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainIntensB">
                                  중간 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainIntens"
                                  id="upperArmPainIntensC"
                                  value="C"
                                  checked={formData.upperArmPainIntens === 'C'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainIntensC">
                                  심한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainIntens"
                                  id="upperArmPainIntensD"
                                  value="D"
                                  checked={formData.upperArmPainIntens === 'D'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainIntensD">
                                  매우 심한 통증
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          4. 지난 1년 동안 이러한 증상을 얼마나 자주
                          경험하셨습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainFreq"
                                  id="upperArmPainFreqA"
                                  value="A"
                                  checked={formData.upperArmPainFreq === 'A'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainFreqA">
                                  6개월에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainFreq"
                                  id="upperArmPainFreqB"
                                  value="B"
                                  checked={formData.upperArmPainFreq === 'B'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainFreqB">
                                  2-3달에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainFreq"
                                  id="upperArmPainFreqC"
                                  value="C"
                                  checked={formData.upperArmPainFreq === 'C'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainFreqC">
                                  1달에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainFreq"
                                  id="upperArmPainFreqD"
                                  value="D"
                                  checked={formData.upperArmPainFreq === 'D'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainFreqD">
                                  1주일에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="upperArmPainFreq"
                                  id="upperArmPainFreqE"
                                  value="E"
                                  checked={formData.upperArmPainFreq === 'E'}
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'upperArmPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="upperArmPainFreqE">매일</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          5. 지난 1주일 동안에도 이러한 증상이 있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekUpperArmPainYn"
                                  id="bfrWeekUpperArmPainYnN"
                                  value="N"
                                  checked={
                                    formData.bfrWeekUpperArmPainYn === 'N'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekUpperArmPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekUpperArmPainYnN">
                                  아니오
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekUpperArmPainYn"
                                  id="bfrWeekUpperArmPainYnY"
                                  value="Y"
                                  checked={
                                    formData.bfrWeekUpperArmPainYn === 'Y'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekUpperArmPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekUpperArmPainYnY">
                                  예
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          6. 지난 1년 동안 이러한 통증으로 인해 어떤 일이
                          있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrUpperArmPainMdtrtYn"
                                  id="bfrYrUpperArmPainMdtrtYnA"
                                  value="A"
                                  checked={
                                    formData.bfrYrUpperArmPainMdtrtYn === 'A'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrUpperArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrUpperArmPainMdtrtYnA">
                                  병원, 한의원 치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrUpperArmPainMdtrtYn"
                                  id="bfrYrUpperArmPainMdtrtYnB"
                                  value="B"
                                  checked={
                                    formData.bfrYrUpperArmPainMdtrtYn === 'B'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrUpperArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrUpperArmPainMdtrtYnB">
                                  약국치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrUpperArmPainMdtrtYn"
                                  id="bfrYrUpperArmPainMdtrtYnC"
                                  value="C"
                                  checked={
                                    formData.bfrYrUpperArmPainMdtrtYn === 'C'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrUpperArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrUpperArmPainMdtrtYnC">
                                  병가, 산재
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrUpperArmPainMdtrtYn"
                                  id="bfrYrUpperArmPainMdtrtYnD"
                                  value="D"
                                  checked={
                                    formData.bfrYrUpperArmPainMdtrtYn === 'D'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrUpperArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrUpperArmPainMdtrtYnD">
                                  작업 전환
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrUpperArmPainMdtrtYn"
                                  id="bfrYrUpperArmPainMdtrtYnE"
                                  value="E"
                                  checked={
                                    formData.bfrYrUpperArmPainMdtrtYn === 'E'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrUpperArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrUpperArmPainMdtrtYnE">
                                  해당사항 없음
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrUpperArmPainMdtrtYn"
                                  id="bfrYrUpperArmPainMdtrtYnF"
                                  value="F"
                                  checked={
                                    formData.bfrYrUpperArmPainMdtrtYn === 'F'
                                  }
                                  disabled={
                                    formData.painYn !== 'Y' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrUpperArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrUpperArmPainMdtrtYnF">
                                  기타
                                </label>{' '}
                                <input
                                  type="text"
                                  className="form-control"
                                  id="bfrYrUpperArmPainMdtrtEtc"
                                  value={
                                    formData.bfrYrUpperArmPainMdtrtEtc || ''
                                  }
                                  disabled={
                                    formData.bfrYrUpperArmPainMdtrtYn != 'F' ||
                                    formData.upperArmPainYn !== 'Y'
                                  }
                                  onChange={handleInputChange}
                                  style={{ marginTop: '12px' }}
                                  maxLength={20}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {/* //통증부위-어꺠 */}
                {/* 통증부위-팔/팔꿈치 */}

                {formData.lowerArmPainYn == 'Y' ? (
                  <div className="txt-box bg-white">
                    <h2 className="box-tit1">통증부위 - 팔/팔꿈치</h2>
                    <div className="box-cnt">
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">1. 통증의 구체적 부위는?</h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainPart"
                                  id="lowerArmPainPartA"
                                  value="A"
                                  checked={formData.lowerArmPainPart === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainPartA">
                                  오른쪽
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainPart"
                                  id="lowerArmPainPartB"
                                  value="B"
                                  checked={formData.lowerArmPainPart === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainPartB">왼쪽</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainPart"
                                  id="lowerArmPainPartC"
                                  value="C"
                                  checked={formData.lowerArmPainPart === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainPartC">
                                  양쪽 모두
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          2. 한번 아프기 시작하면 통증 기간은 얼마 동안
                          지속됩니까?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainPrd"
                                  id="lowerArmPainPrdA"
                                  value="A"
                                  checked={formData.lowerArmPainPrd === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainPrdA">
                                  1일 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainPrd"
                                  id="lowerArmPainPrdB"
                                  value="B"
                                  checked={formData.lowerArmPainPrd === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainPrdB">
                                  1일 - 1주일 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainPrd"
                                  id="lowerArmPainPrdC"
                                  value="C"
                                  checked={formData.lowerArmPainPrd === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainPrdC">
                                  1주일 - 1달 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainPrd"
                                  id="lowerArmPainPrdD"
                                  value="D"
                                  checked={formData.lowerArmPainPrd === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainPrdD">
                                  1달 - 6개월 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainPrd"
                                  id="lowerArmPainPrdE"
                                  value="E"
                                  checked={formData.lowerArmPainPrd === 'E'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainPrdE">
                                  6개월 이상
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          3. 그때의 아픈 정도는 어느 정도 입니까 ?
                        </h3>
                        <ul className="guide-txt" style={{ marginBottom: 0 }}>
                          <li>
                            약한 통증 : 약간 불편한 정도이나 작업에 열중할 때는
                            못 느낀다.
                          </li>
                          <li>
                            중간 통증 : 작업 중 통증이 있으나 귀가 후 휴식을
                            취하면 괜찮다.
                          </li>
                          <li>
                            심한 통증 : 작업 중 통증이 비교적 심하고 귀가 후에도
                            통증이 계속된다.
                          </li>
                          <li>
                            매우 심한 통증 : 통증 때문에 작업은 물론 일상생활을
                            하기가 어렵다.
                          </li>
                        </ul>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainIntens"
                                  id="lowerArmPainIntensA"
                                  value="A"
                                  checked={formData.lowerArmPainIntens === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainIntensA">
                                  약한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainIntens"
                                  id="lowerArmPainIntensB"
                                  value="B"
                                  checked={formData.lowerArmPainIntens === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainIntensB">
                                  중간 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainIntens"
                                  id="lowerArmPainIntensC"
                                  value="C"
                                  checked={formData.lowerArmPainIntens === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainIntensC">
                                  심한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainIntens"
                                  id="lowerArmPainIntensD"
                                  value="D"
                                  checked={formData.lowerArmPainIntens === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainIntensD">
                                  매우 심한 통증
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          4. 지난 1년 동안 이러한 증상을 얼마나 자주
                          경험하셨습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainFreq"
                                  id="lowerArmPainFreqA"
                                  value="A"
                                  checked={formData.lowerArmPainFreq === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainFreqA">
                                  6개월에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainFreq"
                                  id="lowerArmPainFreqB"
                                  value="B"
                                  checked={formData.lowerArmPainFreq === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainFreqB">
                                  2-3달에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainFreq"
                                  id="lowerArmPainFreqC"
                                  value="C"
                                  checked={formData.lowerArmPainFreq === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainFreqC">
                                  1달에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainFreq"
                                  id="lowerArmPainFreqD"
                                  value="D"
                                  checked={formData.lowerArmPainFreq === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainFreqD">
                                  1주일에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="lowerArmPainFreq"
                                  id="lowerArmPainFreqE"
                                  value="E"
                                  checked={formData.lowerArmPainFreq === 'E'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'lowerArmPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="lowerArmPainFreqE">매일</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          5. 지난 1주일 동안에도 이러한 증상이 있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekLowerArmPainYn"
                                  id="bfrWeekLowerArmPainYnN"
                                  value="N"
                                  checked={
                                    formData.bfrWeekLowerArmPainYn === 'N'
                                  }
                                  disabled={formData.painYn == 'N'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekLowerArmPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekLowerArmPainYnN">
                                  아니오
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekLowerArmPainYn"
                                  id="bfrWeekLowerArmPainYnY"
                                  value="Y"
                                  checked={
                                    formData.bfrWeekLowerArmPainYn === 'Y'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekLowerArmPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekLowerArmPainYnY">
                                  예
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          6. 지난 1년 동안 이러한 통증으로 인해 어떤 일이
                          있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLowerArmPainMdtrtYn"
                                  id="bfrYrLowerArmPainMdtrtYnA"
                                  value="A"
                                  checked={
                                    formData.bfrYrLowerArmPainMdtrtYn === 'A'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLowerArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLowerArmPainMdtrtYnA">
                                  병원, 한의원 치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLowerArmPainMdtrtYn"
                                  id="bfrYrLowerArmPainMdtrtYnB"
                                  value="B"
                                  checked={
                                    formData.bfrYrLowerArmPainMdtrtYn === 'B'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLowerArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLowerArmPainMdtrtYnB">
                                  약국 치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLowerArmPainMdtrtYn"
                                  id="bfrYrLowerArmPainMdtrtYnC"
                                  value="C"
                                  checked={
                                    formData.bfrYrLowerArmPainMdtrtYn === 'C'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLowerArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLowerArmPainMdtrtYnC">
                                  병가, 산재
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLowerArmPainMdtrtYn"
                                  id="bfrYrLowerArmPainMdtrtYnD"
                                  value="D"
                                  checked={
                                    formData.bfrYrLowerArmPainMdtrtYn === 'D'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLowerArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLowerArmPainMdtrtYnD">
                                  작업 전환
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLowerArmPainMdtrtYn"
                                  id="bfrYrLowerArmPainMdtrtYnE"
                                  value="E"
                                  checked={
                                    formData.bfrYrLowerArmPainMdtrtYn === 'E'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLowerArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLowerArmPainMdtrtYnE">
                                  해당사항 없음
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLowerArmPainMdtrtYn"
                                  id="bfrYrLowerArmPainMdtrtYnF"
                                  value="F"
                                  checked={
                                    formData.bfrYrLowerArmPainMdtrtYn === 'F'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLowerArmPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLowerArmPainMdtrtYnF">
                                  기타
                                </label>{' '}
                                <input
                                  type="text"
                                  className="form-control"
                                  id="bfrYrLowerArmPainMdtrtEtc"
                                  value={
                                    formData.bfrYrLowerArmPainMdtrtEtc || ''
                                  }
                                  disabled={
                                    formData.bfrYrLowerArmPainMdtrtYn != 'F'
                                  }
                                  onChange={handleInputChange}
                                  style={{ marginTop: '12px' }}
                                  maxLength={20}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {/* //통증부위-팔/팔꿈치 */}
                {/* 통증부위-손목/손가락 */}

                {formData.wristPainYn == 'Y' ? (
                  <div className="txt-box bg-white">
                    <h2 className="box-tit1">통증부위 - 손목/손가락</h2>
                    <div className="box-cnt">
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">1. 통증의 구체적 부위는?</h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainPart"
                                  id="wristPainPartA"
                                  value="A"
                                  checked={formData.wristPainPart === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainPartA">오른쪽</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainPart"
                                  id="wristPainPartB"
                                  value="B"
                                  checked={formData.wristPainPart === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainPartB">왼쪽</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainPart"
                                  id="wristPainPartC"
                                  value="C"
                                  checked={formData.wristPainPart === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainPartC">
                                  양쪽 모두
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          2. 한번 아프기 시작하면 통증 기간은 얼마 동안
                          지속됩니까?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainPrd"
                                  id="wristPainPrdA"
                                  value="A"
                                  checked={formData.wristPainPrd === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainPrdA">1일 미만</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainPrd"
                                  id="wristPainPrdB"
                                  value="B"
                                  checked={formData.wristPainPrd === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainPrdB">
                                  1일 - 1주일 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainPrd"
                                  id="wristPainPrdC"
                                  value="C"
                                  checked={formData.wristPainPrd === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainPrdC">
                                  1주일 - 1달 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainPrd"
                                  id="wristPainPrdD"
                                  value="D"
                                  checked={formData.wristPainPrd === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainPrdD">
                                  1달 - 6개월 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainPrd"
                                  id="wristPainPrdE"
                                  value="E"
                                  checked={formData.wristPainPrdE === 'E'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainPrdE">
                                  6개월 이상
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          3. 그때의 아픈 정도는 어느 정도 입니까 ?
                        </h3>
                        <ul className="guide-txt" style={{ marginBottom: 0 }}>
                          <li>
                            약한 통증 : 약간 불편한 정도이나 작업에 열중할 때는
                            못 느낀다.
                          </li>
                          <li>
                            중간 통증 : 작업 중 통증이 있으나 귀가 후 휴식을
                            취하면 괜찮다.
                          </li>
                          <li>
                            심한 통증 : 작업 중 통증이 비교적 심하고 귀가 후에도
                            통증이 계속된다.
                          </li>
                          <li>
                            매우 심한 통증 : 통증 때문에 작업은 물론 일상생활을
                            하기가 어렵다.
                          </li>
                        </ul>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainIntens"
                                  id="wristPainIntensA"
                                  value="A"
                                  checked={formData.wristPainIntens === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainIntensA">
                                  약한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainIntens"
                                  id="wristPainIntensB"
                                  value="B"
                                  checked={formData.wristPainIntens === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainIntensB">
                                  중간 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainIntens"
                                  id="wristPainIntensC"
                                  value="C"
                                  checked={formData.wristPainIntens === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainIntensC">
                                  심한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainIntens"
                                  id="wristPainIntensD"
                                  value="D"
                                  checked={formData.wristPainIntens === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainIntensD">
                                  매우 심한 통증
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          4. 지난 1년 동안 이러한 증상을 얼마나 자주
                          경험하셨습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainFreq"
                                  id="wristPainFreqA"
                                  value="A"
                                  checked={formData.wristPainFreq === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainFreqA">
                                  6개월에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainFreq"
                                  id="wristPainFreqB"
                                  value="B"
                                  checked={formData.wristPainFreq === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainFreqB">
                                  2-3달에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainFreq"
                                  id="wristPainFreqC"
                                  value="C"
                                  checked={formData.wristPainFreq === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainFreqC">
                                  1달에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainFreq"
                                  id="wristPainFreqD"
                                  value="D"
                                  checked={formData.wristPainFreq === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainFreqD">
                                  1주일에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="wristPainFreq"
                                  id="wristPainFreqE"
                                  value="E"
                                  checked={formData.wristPainFreq === 'E'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'wristPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="wristPainFreqE">매일</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          5. 지난 1주일 동안에도 이러한 증상이 있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekWristPainYn"
                                  id="bfrWeekWristPainYnN"
                                  value="N"
                                  checked={formData.bfrWeekWristPainYn === 'N'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekWristPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekWristPainYnN">
                                  아니오
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekWristPainYn"
                                  id="bfrWeekWristPainYnY"
                                  value="Y"
                                  checked={formData.bfrWeekWristPainYn === 'Y'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekWristPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekWristPainYnY">예</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          6. 지난 1년 동안 이러한 통증으로 인해 어떤 일이
                          있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrWristPainMdtrtYn"
                                  id="bfrYrWristPainMdtrtYnA"
                                  value="A"
                                  checked={
                                    formData.bfrYrWristPainMdtrtYn === 'A'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrWristPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrWristPainMdtrtYnA">
                                  병원, 한의원 치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrWristPainMdtrtYn"
                                  id="bfrYrWristPainMdtrtYnB"
                                  value="B"
                                  checked={
                                    formData.bfrYrWristPainMdtrtYn === 'B'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrWristPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrWristPainMdtrtYnB">
                                  약국치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrWristPainMdtrtYn"
                                  id="bfrYrWristPainMdtrtYnC"
                                  value="C"
                                  checked={
                                    formData.bfrYrWristPainMdtrtYn === 'C'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrWristPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrWristPainMdtrtYnC">
                                  병가, 산재
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrWristPainMdtrtYn"
                                  id="bfrYrWristPainMdtrtYnD"
                                  value="D"
                                  checked={
                                    formData.bfrYrWristPainMdtrtYn === 'D'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrWristPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrWristPainMdtrtYnD">
                                  작업 전환
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrWristPainMdtrtYn"
                                  id="bfrYrWristPainMdtrtYnE"
                                  value="E"
                                  checked={
                                    formData.bfrYrWristPainMdtrtYn === 'E'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrWristPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrWristPainMdtrtYnE">
                                  해당사항 없음
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrWristPainMdtrtYn"
                                  id="bfrYrWristPainMdtrtYnF"
                                  value="F"
                                  checked={
                                    formData.bfrYrWristPainMdtrtYn === 'F'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrWristPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrWristPainMdtrtYnF">
                                  기타
                                </label>{' '}
                                <input
                                  type="text"
                                  className="form-control"
                                  id="bfrYrWristPainMdtrtEtc"
                                  value={formData.bfrYrWristPainMdtrtEtc || ''}
                                  disabled={
                                    formData.bfrYrWristPainMdtrtYn != 'F'
                                  }
                                  onChange={handleInputChange}
                                  style={{ marginTop: '12px' }}
                                  maxLength={20}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {/* //통증부위-손목/손가락 */}
                {/* 통증부위-허리 */}

                {formData.trunkPainYn == 'Y' ? (
                  <div className="txt-box bg-white">
                    <h2 className="box-tit1">통증부위 - 허리</h2>
                    <div className="box-cnt">
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          1. 한번 아프기 시작하면 통증 기간은 얼마 동안
                          지속됩니까?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainPrd"
                                  id="trunkPainPrdA"
                                  value="A"
                                  checked={formData.trunkPainPrd === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainPrdA">1일 미만</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainPrd"
                                  id="trunkPainPrdB"
                                  value="B"
                                  checked={formData.trunkPainPrd === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainPrdB">
                                  1일 - 1주일 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainPrd"
                                  id="trunkPainPrdC"
                                  value="C"
                                  checked={formData.trunkPainPrd === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainPrdC">
                                  1주일 - 1달 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainPrd"
                                  id="trunkPainPrdD"
                                  value="D"
                                  checked={formData.trunkPainPrd === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainPrdD">
                                  1달 - 6개월 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainPrd"
                                  id="trunkPainPrdE"
                                  value="E"
                                  checked={formData.trunkPainPrd === 'E'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainPrdE">
                                  6개월 이상
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          2. 그때의 아픈 정도는 어느 정도 입니까 ?
                        </h3>
                        <ul className="guide-txt" style={{ marginBottom: 0 }}>
                          <li>
                            약한 통증 : 약간 불편한 정도이나 작업에 열중할 때는
                            못 느낀다.
                          </li>
                          <li>
                            중간 통증 : 작업 중 통증이 있으나 귀가 후 휴식을
                            취하면 괜찮다.
                          </li>
                          <li>
                            심한 통증 : 작업 중 통증이 비교적 심하고 귀가 후에도
                            통증이 계속된다.
                          </li>
                          <li>
                            매우 심한 통증 : 통증 때문에 작업은 물론 일상생활을
                            하기가 어렵다.
                          </li>
                        </ul>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainIntens"
                                  id="trunkPainIntensA"
                                  value="A"
                                  checked={formData.trunkPainIntens === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainIntensA">
                                  약한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainIntens"
                                  id="trunkPainIntensB"
                                  value="B"
                                  checked={formData.trunkPainIntens === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainIntensB">
                                  중간 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainIntens"
                                  id="trunkPainIntensC"
                                  value="C"
                                  checked={formData.trunkPainIntens === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainIntensC">
                                  심한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainIntens"
                                  id="trunkPainIntensD"
                                  value="D"
                                  checked={formData.trunkPainIntens === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainIntensD">
                                  매우 심한 통증
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          3. 지난 1년 동안 이러한 증상을 얼마나 자주
                          경험하셨습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainFreq"
                                  id="trunkPainFreqA"
                                  value="A"
                                  checked={formData.trunkPainFreq === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainFreqA">
                                  6개월에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainFreq"
                                  id="trunkPainFreqB"
                                  value="B"
                                  checked={formData.trunkPainFreq === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainFreqB">
                                  2-3달에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainFreq"
                                  id="trunkPainFreqC"
                                  value="C"
                                  checked={formData.trunkPainFreq === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainFreqC">
                                  1달에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainFreq"
                                  id="trunkPainFreqD"
                                  value="D"
                                  checked={formData.trunkPainFreq === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainFreqD">
                                  1주일에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="trunkPainFreq"
                                  id="trunkPainFreqE"
                                  value="E"
                                  checked={formData.trunkPainFreq === 'E'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'trunkPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="trunkPainFreqE">매일</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          4. 지난 1주일 동안에도 이러한 증상이 있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekTrunkPainYn"
                                  id="bfrWeekTrunkPainYnN"
                                  value="N"
                                  checked={formData.bfrWeekTrunkPainYn === 'N'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekTrunkPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekTrunkPainYnN">
                                  아니오
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekTrunkPainYn"
                                  id="bfrWeekTrunkPainYnY"
                                  value="Y"
                                  checked={formData.bfrWeekTrunkPainYn === 'Y'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekTrunkPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekTrunkPainYnY">예</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          5. 지난 1년 동안 이러한 통증으로 인해 어떤 일이
                          있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrTrunkPainMdtrtYn"
                                  id="bfrYrTrunkPainMdtrtYnA"
                                  value="A"
                                  checked={
                                    formData.bfrYrTrunkPainMdtrtYn === 'A'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrTrunkPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrTrunkPainMdtrtYnA">
                                  병원, 한의원 치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrTrunkPainMdtrtYn"
                                  id="bfrYrTrunkPainMdtrtYnB"
                                  value="B"
                                  checked={
                                    formData.bfrYrTrunkPainMdtrtYn === 'B'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrTrunkPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrTrunkPainMdtrtYnB">
                                  약국치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrTrunkPainMdtrtYn"
                                  id="bfrYrTrunkPainMdtrtYnC"
                                  value="C"
                                  checked={
                                    formData.bfrYrTrunkPainMdtrtYn === 'C'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrTrunkPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrTrunkPainMdtrtYnC">
                                  병가, 산재
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrTrunkPainMdtrtYn"
                                  id="bfrYrTrunkPainMdtrtYnD"
                                  value="D"
                                  checked={
                                    formData.bfrYrTrunkPainMdtrtYn === 'D'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrTrunkPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrTrunkPainMdtrtYnD">
                                  작업 전환
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrTrunkPainMdtrtYn"
                                  id="bfrYrTrunkPainMdtrtYnE"
                                  value="E"
                                  checked={
                                    formData.bfrYrTrunkPainMdtrtYn === 'E'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrTrunkPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrTrunkPainMdtrtYnE">
                                  해당사항 없음
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrTrunkPainMdtrtYn"
                                  id="bfrYrTrunkPainMdtrtYnF"
                                  value="F"
                                  checked={
                                    formData.bfrYrTrunkPainMdtrtYn === 'F'
                                  }
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrTrunkPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrTrunkPainMdtrtYnF">
                                  기타
                                </label>{' '}
                                <input
                                  type="text"
                                  className="form-control"
                                  id="bfrYrTrunkPainMdtrtEtc"
                                  value={formData.bfrYrTrunkPainMdtrtEtc || ''}
                                  disabled={
                                    formData.bfrYrTrunkPainMdtrtYn != 'F'
                                  }
                                  onChange={handleInputChange}
                                  style={{ marginTop: '12px' }}
                                  maxLength={20}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {/* //통증부위-허리 */}
                {/* 통증부위-다리/발 */}

                {formData.legPainYn == 'Y' ? (
                  <div className="txt-box bg-white">
                    <h2 className="box-tit1">통증부위 - 다리/발</h2>
                    <div className="box-cnt">
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">1. 통증의 구체적 부위는?</h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainPart"
                                  id="legPainPartA"
                                  value="A"
                                  checked={formData.legPainPart === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainPartA">오른쪽</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainPart"
                                  id="legPainPartB"
                                  value="B"
                                  checked={formData.legPainPart === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainPartB">왼쪽</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainPart"
                                  id="legPainPartC"
                                  value="C"
                                  checked={formData.legPainPart === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainPart',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainPartC">양쪽 모두</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          2. 한번 아프기 시작하면 통증 기간은 얼마 동안
                          지속됩니까?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainPrd"
                                  id="legPainPrdA"
                                  value="A"
                                  checked={formData.legPainPrd === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainPrdA">1일 미만</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainPrd"
                                  id="legPainPrdB"
                                  value="B"
                                  checked={formData.legPainPrd === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainPrdB">
                                  1일 - 1주일 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainPrd"
                                  id="legPainPrdC"
                                  value="C"
                                  checked={formData.legPainPrd === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainPrdC">
                                  1주일 - 1달 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainPrd"
                                  id="legPainPrdD"
                                  value="D"
                                  checked={formData.legPainPrd === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainPrdD">
                                  1달 - 6개월 미만
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainPrd"
                                  id="legPainPrdE"
                                  value="E"
                                  checked={formData.legPainPrd === 'E'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainPrd',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainPrdE">6개월 이상</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          3. 그때의 아픈 정도는 어느 정도 입니까 ?
                        </h3>
                        <ul className="guide-txt" style={{ marginBottom: 0 }}>
                          <li>
                            약한 통증 : 약간 불편한 정도이나 작업에 열중할 때는
                            못 느낀다.
                          </li>
                          <li>
                            중간 통증 : 작업 중 통증이 있으나 귀가 후 휴식을
                            취하면 괜찮다.
                          </li>
                          <li>
                            심한 통증 : 작업 중 통증이 비교적 심하고 귀가 후에도
                            통증이 계속된다.
                          </li>
                          <li>
                            매우 심한 통증 : 통증 때문에 작업은 물론 일상생활을
                            하기가 어렵다.
                          </li>
                        </ul>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainIntens"
                                  id="legPainIntensA"
                                  value="A"
                                  checked={formData.legPainIntens === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainIntensA">
                                  약한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainIntens"
                                  id="legPainIntensB"
                                  value="B"
                                  checked={formData.legPainIntens === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainIntensB">
                                  중간 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainIntens"
                                  id="legPainIntensC"
                                  value="C"
                                  checked={formData.legPainIntens === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainIntensC">
                                  심한 통증
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainIntens"
                                  id="legPainIntensD"
                                  value="D"
                                  checked={formData.legPainIntens === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainIntens',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainIntensD">
                                  매우 심한 통증
                                </label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          4. 지난 1년 동안 이러한 증상을 얼마나 자주
                          경험하셨습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainFreq"
                                  id="legPainFreqA"
                                  value="A"
                                  checked={formData.legPainFreq === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainFreqA">
                                  6개월에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainFreq"
                                  id="legPainFreqB"
                                  value="B"
                                  checked={formData.legPainFreq === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainFreqB">
                                  2-3달에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainFreq"
                                  id="legPainFreqC"
                                  value="C"
                                  checked={formData.legPainFreq === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainFreqC">1달에 1번</label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainFreq"
                                  id="legPainFreqD"
                                  value="D"
                                  checked={formData.legPainFreq === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainFreqD">
                                  1주일에 1번
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="legPainFreq"
                                  id="legPainFreqE"
                                  value="E"
                                  checked={formData.legPainFreq === 'E'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'legPainFreq',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="legPainFreqE">매일</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          5. 지난 1주일 동안에도 이러한 증상이 있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekLegPainYn"
                                  id="bfrWeekLegPainYnN"
                                  value="N"
                                  checked={formData.bfrWeekLegPainYn === 'N'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekLegPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekLegPainYnN">
                                  아니오
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrWeekLegPainYn"
                                  id="bfrWeekLegPainYnY"
                                  value="Y"
                                  checked={formData.bfrWeekLegPainYn === 'Y'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrWeekLegPainYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrWeekLegPainYnY">예</label>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                      {/* */}
                      <div className="box-sec">
                        <h3 className="box-tit2">
                          6. 지난 1년 동안 이러한 통증으로 인해 어떤 일이
                          있었습니까 ?
                        </h3>
                        <div className="form-group full">
                          <div className="form-conts">
                            <div className="row chk-area chk-column">
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLegPainMdtrtYn"
                                  id="bfrYrLegPainMdtrtYnA"
                                  value="A"
                                  checked={formData.bfrYrLegPainMdtrtYn === 'A'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLegPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLegPainMdtrtYnA">
                                  병원, 한의원 치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLegPainMdtrtYn"
                                  id="bfrYrLegPainMdtrtYnB"
                                  value="B"
                                  checked={formData.bfrYrLegPainMdtrtYn === 'B'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLegPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLegPainMdtrtYnB">
                                  약국치료
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLegPainMdtrtYn"
                                  id="bfrYrLegPainMdtrtYnC"
                                  value="C"
                                  checked={formData.bfrYrLegPainMdtrtYn === 'C'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLegPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLegPainMdtrtYnC">
                                  병가, 산재
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLegPainMdtrtYn"
                                  id="bfrYrLegPainMdtrtYnD"
                                  value="D"
                                  checked={formData.bfrYrLegPainMdtrtYn === 'D'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLegPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLegPainMdtrtYnD">
                                  작업 전환
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLegPainMdtrtYn"
                                  id="bfrYrLegPainMdtrtYnE"
                                  value="E"
                                  checked={formData.bfrYrLegPainMdtrtYn === 'E'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLegPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLegPainMdtrtYnE">
                                  해당사항 없음
                                </label>{' '}
                              </div>
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="bfrYrLegPainMdtrtYn"
                                  id="bfrYrLegPainMdtrtYnF"
                                  value="F"
                                  checked={formData.bfrYrLegPainMdtrtYn === 'F'}
                                  disabled={formData.painYn !== 'Y'}
                                  onChange={e =>
                                    handleRadioChange(
                                      'bfrYrLegPainMdtrtYn',
                                      e.target.value
                                    )
                                  }
                                />
                                <label htmlFor="bfrYrLegPainMdtrtYnF">
                                  기타
                                </label>{' '}
                                <input
                                  type="text"
                                  className="form-control"
                                  id="bfrYrLegPainMdtrtEtc"
                                  value={formData.bfrYrLegPainMdtrtEtc || ''}
                                  disabled={formData.bfrYrLegPainMdtrtYn != 'F'}
                                  onChange={handleInputChange}
                                  style={{ marginTop: '12px' }}
                                  maxLength={20}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* // */}
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {/* //통증부위-다리/발 */}
              </div>
              {/* //정보입력 */}
            </div>
          </div>
        </div>
        {/* //컨텐츠 영역 */}
      </div>
      {/* 페이지 버튼 영역 */}
      <div className="page-btn-wrap">
        <button
          type="button"
          className="btn xlg"
          onClick={() => {
            // insertSurveySymptom();
            insertProcess();
          }}
        >
          제출하기
        </button>
      </div>
      {/* //페이지 버튼 영역 */}
    </>
  );
};

export default SurveySymptom;
